export const SHARING_UNIT_STATUS_INIT = 'INIT';
export const SHARING_UNIT_STATUS_AGREED = 'AGREED';
export const SHARING_UNIT_STATUS_DELETED = 'DELETED';
export const SHARING_UNIT_STATUS_DRAFT = 'DRAFT';
export const SHARING_UNIT_STATUS_REFUSED = 'REFUSED';
